/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetSnapshotsKeySettings200,
  PatchSnapshotsKeyBody,
  PatchSnapshotsKeySettings200,
  PatchSnapshotsKeySettingsBody,
  PostSnapshotsBody,
  PostSnapshotsKeyDevicesBody,
  PostSnapshotsKeyLoadBody,
  PostSnapshotsKeyRunAssuranceEngine200,
  PostSnapshotsKeySubsetBody,
  PostSnapshotsKeyUnloadBody,
  PostSnapshotsLoadBodyItem,
  PostSnapshotsUnloadBodyItem,
  PostSnapshotsUpload200,
  PostSnapshotsUploadBody,
  PostTablesManagementSnapshots200,
  PostTablesManagementSnapshotsBody,
  PostTablesSnapshotAttributes200,
  PostTablesSnapshotAttributesBody,
  PostTablesSnapshotDevices200,
  PostTablesSnapshotDevicesBody,
  Snapshot,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Deletes platform snapshots
 * @summary Delete platform snapshots
 */
export const deleteSnapshots = () => {
  return apiClient<unknown>({ url: `/snapshots`, method: 'DELETE' });
};

export const getDeleteSnapshotsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnapshots>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSnapshots>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteSnapshots'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSnapshots>>,
    void
  > = () => {
    return deleteSnapshots();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSnapshotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSnapshots>>
>;

export type DeleteSnapshotsMutationError = unknown;

/**
 * @summary Delete platform snapshots
 */
export const useDeleteSnapshots = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSnapshots>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSnapshots>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteSnapshotsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns information on available snapshots
 * @summary Return information on available snapshots
 */
export const getSnapshots = (signal?: AbortSignal) => {
  return apiClient<Snapshot[]>({ url: `/snapshots`, method: 'GET', signal });
};

export const getGetSnapshotsQueryKey = () => {
  return [`/snapshots`] as const;
};

export const getGetSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSnapshots>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSnapshotsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnapshots>>> = ({
    signal,
  }) => getSnapshots(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshots>>
>;
export type GetSnapshotsQueryError = void;

export function useGetSnapshots<
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSnapshots>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshots>>,
          TError,
          Awaited<ReturnType<typeof getSnapshots>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshots<
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSnapshots>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshots>>,
          TError,
          Awaited<ReturnType<typeof getSnapshots>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshots<
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSnapshots>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return information on available snapshots
 */

export function useGetSnapshots<
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSnapshots>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSnapshotsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates new snapshot with global or new settings
 * @summary Create new snapshot
 */
export const postSnapshots = (
  postSnapshotsBody: PostSnapshotsBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsBody,
    signal,
  });
};

export const getPostSnapshotsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshots>>,
    TError,
    { data: PostSnapshotsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshots>>,
  TError,
  { data: PostSnapshotsBody },
  TContext
> => {
  const mutationKey = ['postSnapshots'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshots>>,
    { data: PostSnapshotsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSnapshots(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshots>>
>;
export type PostSnapshotsMutationBody = PostSnapshotsBody;
export type PostSnapshotsMutationError = unknown;

/**
 * @summary Create new snapshot
 */
export const usePostSnapshots = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshots>>,
      TError,
      { data: PostSnapshotsBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshots>>,
  TError,
  { data: PostSnapshotsBody },
  TContext
> => {
  const mutationOptions = getPostSnapshotsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes the specified snapshot
 * @summary Delete specific snapshot
 */
export const deleteSnapshotsKey = (key: string) => {
  return apiClient<unknown>({ url: `/snapshots/${key}`, method: 'DELETE' });
};

export const getDeleteSnapshotsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnapshotsKey>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSnapshotsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['deleteSnapshotsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSnapshotsKey>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return deleteSnapshotsKey(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSnapshotsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSnapshotsKey>>
>;

export type DeleteSnapshotsKeyMutationError = unknown;

/**
 * @summary Delete specific snapshot
 */
export const useDeleteSnapshotsKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSnapshotsKey>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSnapshotsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getDeleteSnapshotsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns information on the specified snapshot
 * @summary Return information on specific snapshot
 */
export const getSnapshotsKey = (key: string, signal?: AbortSignal) => {
  return apiClient<Snapshot>({
    url: `/snapshots/${key}`,
    method: 'GET',
    signal,
  });
};

export const getGetSnapshotsKeyQueryKey = (key: string) => {
  return [`/snapshots/${key}`] as const;
};

export const getGetSnapshotsKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshotsKey>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKey>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSnapshotsKeyQueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnapshotsKey>>> = ({
    signal,
  }) => getSnapshotsKey(key, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshotsKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSnapshotsKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshotsKey>>
>;
export type GetSnapshotsKeyQueryError = void;

export function useGetSnapshotsKey<
  TData = Awaited<ReturnType<typeof getSnapshotsKey>>,
  TError = void,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKey>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKey<
  TData = Awaited<ReturnType<typeof getSnapshotsKey>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKey>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKey<
  TData = Awaited<ReturnType<typeof getSnapshotsKey>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKey>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return information on specific snapshot
 */

export function useGetSnapshotsKey<
  TData = Awaited<ReturnType<typeof getSnapshotsKey>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKey>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSnapshotsKeyQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates name or note for the specified snapshot
 * @summary Update specific snapshot properties
 */
export const patchSnapshotsKey = (
  key: string,
  patchSnapshotsKeyBody: PatchSnapshotsKeyBody,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchSnapshotsKeyBody,
  });
};

export const getPatchSnapshotsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSnapshotsKey>>,
    TError,
    { key: string; data: PatchSnapshotsKeyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSnapshotsKey>>,
  TError,
  { key: string; data: PatchSnapshotsKeyBody },
  TContext
> => {
  const mutationKey = ['patchSnapshotsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSnapshotsKey>>,
    { key: string; data: PatchSnapshotsKeyBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return patchSnapshotsKey(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSnapshotsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSnapshotsKey>>
>;
export type PatchSnapshotsKeyMutationBody = PatchSnapshotsKeyBody;
export type PatchSnapshotsKeyMutationError = unknown;

/**
 * @summary Update specific snapshot properties
 */
export const usePatchSnapshotsKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSnapshotsKey>>,
      TError,
      { key: string; data: PatchSnapshotsKeyBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSnapshotsKey>>,
  TError,
  { key: string; data: PatchSnapshotsKeyBody },
  TContext
> => {
  const mutationOptions = getPatchSnapshotsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Clones snapshot and save as unloaded
 * @summary Clone snapshot
 */
export const postSnapshotsKeyClone = (key: string, signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/clone`,
    method: 'POST',
    signal,
  });
};

export const getPostSnapshotsKeyCloneMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyClone>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyClone>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyClone'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyClone>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return postSnapshotsKeyClone(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyCloneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyClone>>
>;

export type PostSnapshotsKeyCloneMutationError = unknown;

/**
 * @summary Clone snapshot
 */
export const usePostSnapshotsKeyClone = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyClone>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyClone>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeyCloneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes the list of devices (SN) provided in the payload
 * @summary Delete snapshot devices
 */
export const deleteSnapshotsKeyDevices = (key: string) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/devices`,
    method: 'DELETE',
  });
};

export const getDeleteSnapshotsKeyDevicesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnapshotsKeyDevices>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSnapshotsKeyDevices>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['deleteSnapshotsKeyDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSnapshotsKeyDevices>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return deleteSnapshotsKeyDevices(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSnapshotsKeyDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSnapshotsKeyDevices>>
>;

export type DeleteSnapshotsKeyDevicesMutationError = unknown;

/**
 * @summary Delete snapshot devices
 */
export const useDeleteSnapshotsKeyDevices = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSnapshotsKeyDevices>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSnapshotsKeyDevices>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getDeleteSnapshotsKeyDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Refreshes the list of devices (SN) provided in the payload
 * @summary Refresh snapshot devices
 */
export const postSnapshotsKeyDevices = (
  key: string,
  postSnapshotsKeyDevicesBody: PostSnapshotsKeyDevicesBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsKeyDevicesBody,
    signal,
  });
};

export const getPostSnapshotsKeyDevicesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyDevices>>,
    TError,
    { key: string; data: PostSnapshotsKeyDevicesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyDevices>>,
  TError,
  { key: string; data: PostSnapshotsKeyDevicesBody },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyDevices>>,
    { key: string; data: PostSnapshotsKeyDevicesBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return postSnapshotsKeyDevices(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyDevices>>
>;
export type PostSnapshotsKeyDevicesMutationBody = PostSnapshotsKeyDevicesBody;
export type PostSnapshotsKeyDevicesMutationError = unknown;

/**
 * @summary Refresh snapshot devices
 */
export const usePostSnapshotsKeyDevices = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyDevices>>,
      TError,
      { key: string; data: PostSnapshotsKeyDevicesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyDevices>>,
  TError,
  { key: string; data: PostSnapshotsKeyDevicesBody },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeyDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Streams the device json file from the file system as the json response to the client
 * @summary Get raw device json file for a snapshot
 */
export const getSnapshotsKeyDevicesIdJson = (
  key: string,
  id: string,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/devices/${id}/json`,
    method: 'GET',
    signal,
  });
};

export const getGetSnapshotsKeyDevicesIdJsonQueryKey = (
  key: string,
  id: string,
) => {
  return [`/snapshots/${key}/devices/${id}/json`] as const;
};

export const getGetSnapshotsKeyDevicesIdJsonQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
  TError = unknown,
>(
  key: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSnapshotsKeyDevicesIdJsonQueryKey(key, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>
  > = ({ signal }) => getSnapshotsKeyDevicesIdJson(key, id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(key && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSnapshotsKeyDevicesIdJsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>
>;
export type GetSnapshotsKeyDevicesIdJsonQueryError = unknown;

export function useGetSnapshotsKeyDevicesIdJson<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
  TError = unknown,
>(
  key: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKeyDevicesIdJson<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
  TError = unknown,
>(
  key: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKeyDevicesIdJson<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
  TError = unknown,
>(
  key: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get raw device json file for a snapshot
 */

export function useGetSnapshotsKeyDevicesIdJson<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
  TError = unknown,
>(
  key: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDevicesIdJson>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSnapshotsKeyDevicesIdJsonQueryOptions(
    key,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Initiates the snapshot download job
 * @summary Initiate snapshot download job
 */
export const getSnapshotsKeyDownload = (key: string, signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/download`,
    method: 'GET',
    signal,
  });
};

export const getGetSnapshotsKeyDownloadQueryKey = (key: string) => {
  return [`/snapshots/${key}/download`] as const;
};

export const getGetSnapshotsKeyDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSnapshotsKeyDownloadQueryKey(key);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSnapshotsKeyDownload>>
  > = ({ signal }) => getSnapshotsKeyDownload(key, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSnapshotsKeyDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshotsKeyDownload>>
>;
export type GetSnapshotsKeyDownloadQueryError = unknown;

export function useGetSnapshotsKeyDownload<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
  TError = unknown,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKeyDownload>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKeyDownload<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKeyDownload>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKeyDownload<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Initiate snapshot download job
 */

export function useGetSnapshotsKeyDownload<
  TData = Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeyDownload>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSnapshotsKeyDownloadQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Loads snapshot to Random Access Memory (RAM)
 * @summary Load snapshot
 */
export const postSnapshotsKeyLoad = (
  key: string,
  postSnapshotsKeyLoadBody: PostSnapshotsKeyLoadBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/load`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsKeyLoadBody,
    signal,
  });
};

export const getPostSnapshotsKeyLoadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyLoad>>,
    TError,
    { key: string; data: PostSnapshotsKeyLoadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyLoad>>,
  TError,
  { key: string; data: PostSnapshotsKeyLoadBody },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyLoad'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyLoad>>,
    { key: string; data: PostSnapshotsKeyLoadBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return postSnapshotsKeyLoad(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyLoadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyLoad>>
>;
export type PostSnapshotsKeyLoadMutationBody = PostSnapshotsKeyLoadBody;
export type PostSnapshotsKeyLoadMutationError = unknown;

/**
 * @summary Load snapshot
 */
export const usePostSnapshotsKeyLoad = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyLoad>>,
      TError,
      { key: string; data: PostSnapshotsKeyLoadBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyLoad>>,
  TError,
  { key: string; data: PostSnapshotsKeyLoadBody },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeyLoadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Locks the snapshot in loaded area
 * @summary Lock snapshot
 */
export const postSnapshotsKeyLock = (key: string, signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/lock`,
    method: 'POST',
    signal,
  });
};

export const getPostSnapshotsKeyLockMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyLock>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyLock>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyLock'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyLock>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return postSnapshotsKeyLock(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyLockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyLock>>
>;

export type PostSnapshotsKeyLockMutationError = unknown;

/**
 * @summary Lock snapshot
 */
export const usePostSnapshotsKeyLock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyLock>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyLock>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeyLockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Schedules the assurance engine (post-discovery actions, e.g. topology calculation) for a snapshot in the `canceled` state. The assurance engine may be run at most once per load of a snapshot.

 * @summary Trigger assurance engine for snapshot
 */
export const postSnapshotsKeyRunAssuranceEngine = (
  key: string,
  signal?: AbortSignal,
) => {
  return apiClient<PostSnapshotsKeyRunAssuranceEngine200>({
    url: `/snapshots/${key}/run-assurance-engine`,
    method: 'POST',
    signal,
  });
};

export const getPostSnapshotsKeyRunAssuranceEngineMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyRunAssuranceEngine>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyRunAssuranceEngine>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyRunAssuranceEngine'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyRunAssuranceEngine>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return postSnapshotsKeyRunAssuranceEngine(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyRunAssuranceEngineMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyRunAssuranceEngine>>
>;

export type PostSnapshotsKeyRunAssuranceEngineMutationError = void;

/**
 * @summary Trigger assurance engine for snapshot
 */
export const usePostSnapshotsKeyRunAssuranceEngine = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyRunAssuranceEngine>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyRunAssuranceEngine>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions =
    getPostSnapshotsKeyRunAssuranceEngineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns snapshot settings
 * @summary Return snapshot settings
 */
export const getSnapshotsKeySettings = (key: string, signal?: AbortSignal) => {
  return apiClient<GetSnapshotsKeySettings200>({
    url: `/snapshots/${key}/settings`,
    method: 'GET',
    signal,
  });
};

export const getGetSnapshotsKeySettingsQueryKey = (key: string) => {
  return [`/snapshots/${key}/settings`] as const;
};

export const getGetSnapshotsKeySettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSnapshotsKeySettingsQueryKey(key);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSnapshotsKeySettings>>
  > = ({ signal }) => getSnapshotsKeySettings(key, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSnapshotsKeySettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshotsKeySettings>>
>;
export type GetSnapshotsKeySettingsQueryError = unknown;

export function useGetSnapshotsKeySettings<
  TData = Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
  TError = unknown,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKeySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKeySettings<
  TData = Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotsKeySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSnapshotsKeySettings<
  TData = Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return snapshot settings
 */

export function useGetSnapshotsKeySettings<
  TData = Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSnapshotsKeySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSnapshotsKeySettingsQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Modifies subset of snapshot settings.

**Authentication methods:** Each `credential` must have either a `password` or `privateKey`. 
`passphrase` is optional and only used to unlock an encrypted `privateKey`.

**Security notice:** An SSH private key is sensitive information. When you add it here, 
IP Fabric stores it encrypted and uses it to authenticate to matching network devices. 
Only add keys that are approved for this purpose and limited to the required devices.

**Important:** Once created, credentials cannot be retrieved in plaintext form
due to encryption. Only updates and deletions are supported via their UUID.

 * @summary Update snapshot settings
 */
export const patchSnapshotsKeySettings = (
  key: string,
  patchSnapshotsKeySettingsBody: PatchSnapshotsKeySettingsBody,
) => {
  return apiClient<PatchSnapshotsKeySettings200>({
    url: `/snapshots/${key}/settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchSnapshotsKeySettingsBody,
  });
};

export const getPatchSnapshotsKeySettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSnapshotsKeySettings>>,
    TError,
    { key: string; data: PatchSnapshotsKeySettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSnapshotsKeySettings>>,
  TError,
  { key: string; data: PatchSnapshotsKeySettingsBody },
  TContext
> => {
  const mutationKey = ['patchSnapshotsKeySettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSnapshotsKeySettings>>,
    { key: string; data: PatchSnapshotsKeySettingsBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return patchSnapshotsKeySettings(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSnapshotsKeySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSnapshotsKeySettings>>
>;
export type PatchSnapshotsKeySettingsMutationBody =
  PatchSnapshotsKeySettingsBody;
export type PatchSnapshotsKeySettingsMutationError = unknown;

/**
 * @summary Update snapshot settings
 */
export const usePatchSnapshotsKeySettings = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSnapshotsKeySettings>>,
      TError,
      { key: string; data: PatchSnapshotsKeySettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSnapshotsKeySettings>>,
  TError,
  { key: string; data: PatchSnapshotsKeySettingsBody },
  TContext
> => {
  const mutationOptions = getPatchSnapshotsKeySettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Rewrites snapshot settings based on global for Vendors API
 * @summary Rewrite snapshot settings based on global for Vendors API
 */
export const postSnapshotsKeySettingsVendorApiFromGlobal = (
  key: string,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/settings/vendor-api-from-global`,
    method: 'POST',
    signal,
  });
};

export const getPostSnapshotsKeySettingsVendorApiFromGlobalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeySettingsVendorApiFromGlobal>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeySettingsVendorApiFromGlobal>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeySettingsVendorApiFromGlobal'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeySettingsVendorApiFromGlobal>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return postSnapshotsKeySettingsVendorApiFromGlobal(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeySettingsVendorApiFromGlobalMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postSnapshotsKeySettingsVendorApiFromGlobal>>
  >;

export type PostSnapshotsKeySettingsVendorApiFromGlobalMutationError = unknown;

/**
 * @summary Rewrite snapshot settings based on global for Vendors API
 */
export const usePostSnapshotsKeySettingsVendorApiFromGlobal = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeySettingsVendorApiFromGlobal>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeySettingsVendorApiFromGlobal>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions =
    getPostSnapshotsKeySettingsVendorApiFromGlobalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Start a subset snapshot - only selected devices will be discovered
 */
export const postSnapshotsKeySubset = (
  key: string,
  postSnapshotsKeySubsetBody: PostSnapshotsKeySubsetBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/subset`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsKeySubsetBody,
    signal,
  });
};

export const getPostSnapshotsKeySubsetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeySubset>>,
    TError,
    { key: string; data: PostSnapshotsKeySubsetBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeySubset>>,
  TError,
  { key: string; data: PostSnapshotsKeySubsetBody },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeySubset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeySubset>>,
    { key: string; data: PostSnapshotsKeySubsetBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return postSnapshotsKeySubset(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeySubsetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeySubset>>
>;
export type PostSnapshotsKeySubsetMutationBody = PostSnapshotsKeySubsetBody;
export type PostSnapshotsKeySubsetMutationError = unknown;

/**
 * @summary Start a subset snapshot - only selected devices will be discovered
 */
export const usePostSnapshotsKeySubset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeySubset>>,
      TError,
      { key: string; data: PostSnapshotsKeySubsetBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeySubset>>,
  TError,
  { key: string; data: PostSnapshotsKeySubsetBody },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeySubsetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unloads snapshot from Random Access Memory (RAM)
 * @summary Unload snapshot
 */
export const postSnapshotsKeyUnload = (
  key: string,
  postSnapshotsKeyUnloadBody: PostSnapshotsKeyUnloadBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/unload`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsKeyUnloadBody,
    signal,
  });
};

export const getPostSnapshotsKeyUnloadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyUnload>>,
    TError,
    { key: string; data: PostSnapshotsKeyUnloadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyUnload>>,
  TError,
  { key: string; data: PostSnapshotsKeyUnloadBody },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyUnload'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyUnload>>,
    { key: string; data: PostSnapshotsKeyUnloadBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return postSnapshotsKeyUnload(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyUnloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyUnload>>
>;
export type PostSnapshotsKeyUnloadMutationBody = PostSnapshotsKeyUnloadBody;
export type PostSnapshotsKeyUnloadMutationError = unknown;

/**
 * @summary Unload snapshot
 */
export const usePostSnapshotsKeyUnload = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyUnload>>,
      TError,
      { key: string; data: PostSnapshotsKeyUnloadBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyUnload>>,
  TError,
  { key: string; data: PostSnapshotsKeyUnloadBody },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeyUnloadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unlocks the snapshot in loaded area (RAM)
 * @summary Unlock snapshot
 */
export const postSnapshotsKeyUnlock = (key: string, signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/snapshots/${key}/unlock`,
    method: 'POST',
    signal,
  });
};

export const getPostSnapshotsKeyUnlockMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsKeyUnlock>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsKeyUnlock>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['postSnapshotsKeyUnlock'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsKeyUnlock>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return postSnapshotsKeyUnlock(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsKeyUnlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsKeyUnlock>>
>;

export type PostSnapshotsKeyUnlockMutationError = unknown;

/**
 * @summary Unlock snapshot
 */
export const usePostSnapshotsKeyUnlock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsKeyUnlock>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsKeyUnlock>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getPostSnapshotsKeyUnlockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Loads snapshots from HDD to RAM
 * @summary Load snapshots
 */
export const postSnapshotsLoad = (
  postSnapshotsLoadBodyItem: PostSnapshotsLoadBodyItem[],
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/load`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsLoadBodyItem,
    signal,
  });
};

export const getPostSnapshotsLoadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsLoad>>,
    TError,
    { data: PostSnapshotsLoadBodyItem[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsLoad>>,
  TError,
  { data: PostSnapshotsLoadBodyItem[] },
  TContext
> => {
  const mutationKey = ['postSnapshotsLoad'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsLoad>>,
    { data: PostSnapshotsLoadBodyItem[] }
  > = (props) => {
    const { data } = props ?? {};

    return postSnapshotsLoad(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsLoadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsLoad>>
>;
export type PostSnapshotsLoadMutationBody = PostSnapshotsLoadBodyItem[];
export type PostSnapshotsLoadMutationError = unknown;

/**
 * @summary Load snapshots
 */
export const usePostSnapshotsLoad = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsLoad>>,
      TError,
      { data: PostSnapshotsLoadBodyItem[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsLoad>>,
  TError,
  { data: PostSnapshotsLoadBodyItem[] },
  TContext
> => {
  const mutationOptions = getPostSnapshotsLoadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unloads snapshots from RAM to HDD
 * @summary Unload snapshots from HDD to RAM
 */
export const postSnapshotsUnload = (
  postSnapshotsUnloadBodyItem: PostSnapshotsUnloadBodyItem[],
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/snapshots/unload`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSnapshotsUnloadBodyItem,
    signal,
  });
};

export const getPostSnapshotsUnloadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsUnload>>,
    TError,
    { data: PostSnapshotsUnloadBodyItem[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsUnload>>,
  TError,
  { data: PostSnapshotsUnloadBodyItem[] },
  TContext
> => {
  const mutationKey = ['postSnapshotsUnload'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsUnload>>,
    { data: PostSnapshotsUnloadBodyItem[] }
  > = (props) => {
    const { data } = props ?? {};

    return postSnapshotsUnload(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsUnloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsUnload>>
>;
export type PostSnapshotsUnloadMutationBody = PostSnapshotsUnloadBodyItem[];
export type PostSnapshotsUnloadMutationError = unknown;

/**
 * @summary Unload snapshots from HDD to RAM
 */
export const usePostSnapshotsUnload = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsUnload>>,
      TError,
      { data: PostSnapshotsUnloadBodyItem[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsUnload>>,
  TError,
  { data: PostSnapshotsUnloadBodyItem[] },
  TContext
> => {
  const mutationOptions = getPostSnapshotsUnloadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Uploads snapshot into the platform
 * @summary Upload snapshot
 */
export const postSnapshotsUpload = (
  postSnapshotsUploadBody: PostSnapshotsUploadBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, postSnapshotsUploadBody.file);

  return apiClient<PostSnapshotsUpload200>({
    url: `/snapshots/upload`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getPostSnapshotsUploadMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSnapshotsUpload>>,
    TError,
    { data: PostSnapshotsUploadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSnapshotsUpload>>,
  TError,
  { data: PostSnapshotsUploadBody },
  TContext
> => {
  const mutationKey = ['postSnapshotsUpload'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSnapshotsUpload>>,
    { data: PostSnapshotsUploadBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSnapshotsUpload(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSnapshotsUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSnapshotsUpload>>
>;
export type PostSnapshotsUploadMutationBody = PostSnapshotsUploadBody;
export type PostSnapshotsUploadMutationError = void;

/**
 * @summary Upload snapshot
 */
export const usePostSnapshotsUpload = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSnapshotsUpload>>,
      TError,
      { data: PostSnapshotsUploadBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSnapshotsUpload>>,
  TError,
  { data: PostSnapshotsUploadBody },
  TContext
> => {
  const mutationOptions = getPostSnapshotsUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary POST /tables/management/snapshots
 */
export const postTablesManagementSnapshots = (
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesManagementSnapshots200>({
    url: `/tables/management/snapshots`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesManagementSnapshotsBody,
    signal,
  });
};

export const getPostTablesManagementSnapshotsQueryKey = (
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
) => {
  return [
    `/tables/management/snapshots`,
    postTablesManagementSnapshotsBody,
  ] as const;
};

export const getPostTablesManagementSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
  TError = unknown,
>(
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesManagementSnapshotsQueryKey(postTablesManagementSnapshotsBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesManagementSnapshots>>
  > = ({ signal }) =>
    postTablesManagementSnapshots(postTablesManagementSnapshotsBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesManagementSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesManagementSnapshots>>
>;
export type PostTablesManagementSnapshotsQueryError = unknown;

export function usePostTablesManagementSnapshots<
  TData = Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
  TError = unknown,
>(
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
          TError,
          Awaited<ReturnType<typeof postTablesManagementSnapshots>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesManagementSnapshots<
  TData = Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
  TError = unknown,
>(
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
          TError,
          Awaited<ReturnType<typeof postTablesManagementSnapshots>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesManagementSnapshots<
  TData = Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
  TError = unknown,
>(
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/management/snapshots
 */

export function usePostTablesManagementSnapshots<
  TData = Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
  TError = unknown,
>(
  postTablesManagementSnapshotsBody: PostTablesManagementSnapshotsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementSnapshots>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesManagementSnapshotsQueryOptions(
    postTablesManagementSnapshotsBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/snapshot-attributes
 */
export const postTablesSnapshotAttributes = (
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesSnapshotAttributes200>({
    url: `/tables/snapshot-attributes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesSnapshotAttributesBody,
    signal,
  });
};

export const getPostTablesSnapshotAttributesQueryKey = (
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
) => {
  return [
    `/tables/snapshot-attributes`,
    postTablesSnapshotAttributesBody,
  ] as const;
};

export const getPostTablesSnapshotAttributesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
  TError = unknown,
>(
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesSnapshotAttributesQueryKey(postTablesSnapshotAttributesBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesSnapshotAttributes>>
  > = ({ signal }) =>
    postTablesSnapshotAttributes(postTablesSnapshotAttributesBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesSnapshotAttributesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesSnapshotAttributes>>
>;
export type PostTablesSnapshotAttributesQueryError = unknown;

export function usePostTablesSnapshotAttributes<
  TData = Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
  TError = unknown,
>(
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
          TError,
          Awaited<ReturnType<typeof postTablesSnapshotAttributes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesSnapshotAttributes<
  TData = Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
  TError = unknown,
>(
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
          TError,
          Awaited<ReturnType<typeof postTablesSnapshotAttributes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesSnapshotAttributes<
  TData = Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
  TError = unknown,
>(
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/snapshot-attributes
 */

export function usePostTablesSnapshotAttributes<
  TData = Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
  TError = unknown,
>(
  postTablesSnapshotAttributesBody: PostTablesSnapshotAttributesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotAttributes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesSnapshotAttributesQueryOptions(
    postTablesSnapshotAttributesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/snapshot-devices
 */
export const postTablesSnapshotDevices = (
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesSnapshotDevices200>({
    url: `/tables/snapshot-devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesSnapshotDevicesBody,
    signal,
  });
};

export const getPostTablesSnapshotDevicesQueryKey = (
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
) => {
  return [`/tables/snapshot-devices`, postTablesSnapshotDevicesBody] as const;
};

export const getPostTablesSnapshotDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
  TError = unknown,
>(
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesSnapshotDevicesQueryKey(postTablesSnapshotDevicesBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesSnapshotDevices>>
  > = ({ signal }) =>
    postTablesSnapshotDevices(postTablesSnapshotDevicesBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesSnapshotDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesSnapshotDevices>>
>;
export type PostTablesSnapshotDevicesQueryError = unknown;

export function usePostTablesSnapshotDevices<
  TData = Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
  TError = unknown,
>(
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
          TError,
          Awaited<ReturnType<typeof postTablesSnapshotDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesSnapshotDevices<
  TData = Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
  TError = unknown,
>(
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
          TError,
          Awaited<ReturnType<typeof postTablesSnapshotDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesSnapshotDevices<
  TData = Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
  TError = unknown,
>(
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/snapshot-devices
 */

export function usePostTablesSnapshotDevices<
  TData = Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
  TError = unknown,
>(
  postTablesSnapshotDevicesBody: PostTablesSnapshotDevicesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSnapshotDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesSnapshotDevicesQueryOptions(
    postTablesSnapshotDevicesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
